import React, { FC, memo } from "react";
import { Dropdown, Flex } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { CoordinatesInputTypesSwitch, SpatialReferenceDropdownContainer } from "../styled";

import { AttributeOption, ImportAttribute, SpatialReferenceBlockProps } from "../types";

const getAllAttributesNames = (attributes?: ImportAttribute[]): AttributeOption[] =>
  attributes ? attributes.map(({ name }) => ({ text: name, value: name })) : [];

const SpatialReferenceBlockComponent: FC<SpatialReferenceBlockProps> = ({
  srFields,
  attributes,
  updateSrField,
  lonLatInOneField,
  setLonLatInOneField,
  geometrySpecified,
}) => {
  const { t } = useTranslation("dialogs");
  const attributesOptions = getAllAttributesNames(attributes);

  const srDropdownProps = {
    zIndex: 120,
    width: lonLatInOneField ? "29rem" : "14.5rem",
    menuHeight: "10rem",
    options: attributesOptions,
    disabled: !attributesOptions.length,
  };

  return (
    <Flex style={{ flexGrow: 1 }}>
      <Flex style={{ width: "100%" }}>
        <SpatialReferenceDropdownContainer>
          {lonLatInOneField ? (
            <Dropdown
              {...srDropdownProps}
              label={`${t("import.longitude")} (X, Longitude) ; ${t("import.latitude")} (Y, Latitude)`}
              placeholder={t("import.setField")}
              value={srFields.longitudeAndLatitude}
              disabled={geometrySpecified}
              id={"coordinates"}
              onChange={options => updateSrField("longitudeAndLatitude", options[0].value)}
            />
          ) : (
            <>
              <Dropdown
                {...srDropdownProps}
                label={`${t("import.longitude")} (X)`}
                placeholder={t("import.setField")}
                value={srFields.longitude}
                id={"longitude"}
                onChange={options => updateSrField("longitude", options[0].value)}
              />
              <Dropdown
                {...srDropdownProps}
                label={`${t("import.latitude")} (Y)`}
                placeholder={t("import.setField")}
                value={srFields.latitude}
                id={"latitude"}
                onChange={options => updateSrField("latitude", options[0].value)}
              />
            </>
          )}
        </SpatialReferenceDropdownContainer>
        <CoordinatesInputTypesSwitch
          checked={lonLatInOneField}
          disabled={geometrySpecified}
          isOn={!geometrySpecified}
          title={t("import.sameColumnCoordsMessage")}
          onChange={() => setLonLatInOneField(!lonLatInOneField)}
          label={t("import.sameColumnCoordsTitle")}
        />
      </Flex>
    </Flex>
  );
};

export const SpatialReferenceBlock = memo(SpatialReferenceBlockComponent);
